import { render, staticRenderFns } from "./HomeHero.vue?vue&type=template&id=937bb61a&scoped=true&"
import script from "./HomeHero.vue?vue&type=script&lang=js&"
export * from "./HomeHero.vue?vue&type=script&lang=js&"
import style0 from "./HomeHero.vue?vue&type=style&index=0&id=937bb61a&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "937bb61a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Video: require('/vercel/path0/components/elements/Video.vue').default,Section: require('/vercel/path0/components/elements/Section.vue').default})
